import { render, staticRenderFns } from "./ShiftKinds.vue?vue&type=template&id=b307f24c&"
import script from "./ShiftKinds.vue?vue&type=script&lang=ts&"
export * from "./ShiftKinds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports